/** @graphql cc **/

import gql from 'graphql-tag';

export const FocusedInlineCommentQuery = gql`
	query FocusedInlineCommentQuery($commentId: ID!, $contentId: ID) {
		content(id: $contentId) {
			nodes {
				id
				type
				space {
					id
				}
				operations {
					operation
					targetType
				}
			}
		}
		comments(commentId: $commentId, depth: ALL, type: UNRESOLVED) {
			nodes {
				ancestors {
					id
					body(representation: ATLAS_DOC_FORMAT) {
						value
					}
					createdAt {
						value
					}
					createdAtNonLocalized
					isInlineComment
					permissions {
						isEditable
						isRemovable
						isResolvable
					}
					version {
						by {
							displayName
						}
						when
						number
					}
					links {
						webui
						editui
					}
					author {
						displayName
						profilePicture {
							path
						}
						permissionType
						... on KnownUser {
							accountId
						}
						... on User {
							accountId
						}
					}
					replies {
						id
						body(representation: ATLAS_DOC_FORMAT) {
							value
						}
						createdAt {
							value
						}
						createdAtNonLocalized
						isInlineComment
						permissions {
							isEditable
							isRemovable
							isResolvable
						}
						version {
							by {
								displayName
							}
							when
							number
						}
						links {
							webui
							editui
						}
						author {
							displayName
							profilePicture {
								path
							}
							permissionType
							... on KnownUser {
								accountId
							}
							... on User {
								accountId
							}
						}
					}
				}
				id
				body(representation: ATLAS_DOC_FORMAT) {
					value
				}
				createdAt {
					value
				}
				createdAtNonLocalized
				isInlineComment
				permissions {
					isEditable
					isRemovable
					isResolvable
				}
				version {
					by {
						displayName
					}
					when
					number
				}
				links {
					webui
					editui
				}
				author {
					displayName
					profilePicture {
						path
					}
					permissionType
					... on KnownUser {
						accountId
					}
					... on User {
						accountId
					}
				}
				replies {
					id
					body(representation: ATLAS_DOC_FORMAT) {
						value
					}
					createdAt {
						value
					}
					createdAtNonLocalized
					isInlineComment
					permissions {
						isEditable
						isRemovable
						isResolvable
					}
					version {
						by {
							displayName
						}
						when
						number
					}
					links {
						webui
						editui
					}
					author {
						displayName
						profilePicture {
							path
						}
						permissionType
						... on KnownUser {
							accountId
						}
						... on User {
							accountId
						}
					}
				}
			}
		}
		user: confluence_atlassianUser(current: true) {
			id
			displayName
			photos {
				value
				isPrimary
			}
		}
	}
`;
